import { useTranslate } from '../../application/i18n/LocaleProvider';
import { isUrgent, remainingShare } from '../../domain/game/duelClock';

/**
 * The countdown, DIRECTLY UNDER THE PAIR (SPEC-007 D-52).
 *
 * ONE DRAWING, AND IT IS THE BAR. It used to be two — a digit to glance at and a
 * drain to see without looking — on the argument that they answer different
 * questions. They do, and the digit still lost: it is the only thing on this
 * screen that asks the reader to READ a number while a question is open, and a
 * reader who is counting seconds is a reader who is not looking at two cars. The
 * bar says the same thing in the channel that costs nothing to read, and under
 * five seconds it goes to the heat ramp, pulses, and starts ticking out loud.
 *
 * The seconds are still on the element, as its `aria-label`. A screen reader is
 * given the allowance once per round; what left is the pixels.
 *
 * A BAND OF ITS OWN, FULL WIDTH, UNDER THE CARDS — where it was a 52px column
 * at the right-hand end of the scoreboard. Both halves of that move matter. A
 * bar the width of the screen is read peripherally, which is the only way a
 * clock is read while the eyes are on the game; and under the pair it is inside
 * the same glance as the two cards, where at the top of the screen it was a
 * separate look the reader had to decide to take.
 *
 * Its own component rather than a band of `DuelScoreboard`, because the two are
 * no longer next to each other and a component that renders in two places on the
 * screen is two components (SPEC-007 D-58).
 *
 * Announced once per round rather than per second: `aria-label` names the
 * allowance and the digit is `aria-hidden`, so a screen reader is not read a
 * countdown it cannot stop. That is the whole reason this is not a live region.
 */
export default function DuelClock({ run }) {
    const t = useTranslate();
    const isRunning = run.status === 'asking';
    const urgent = isRunning && isUrgent(run.seconds);

    return (
        <div
            className={`duel-clock${urgent ? ' duel-clock--urgent' : ''}${isRunning ? '' : ' duel-clock--stopped'}`}
            style={{ '--clock-remaining': isRunning ? remainingShare(run.seconds, run.round) : 0 }}
            role="timer"
            aria-label={t('duel.clock', { count: run.seconds })}
        >
            <span className="duel-clock__track" aria-hidden="true">
                <span className="duel-clock__drain" />
            </span>
        </div>
    );
}
